<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.58356 1.1848C5.52473 0.959523 7.499 0.84375 9.5 0.84375C11.501 0.84375 13.4753 0.959523 15.4164 1.1848C16.9762 1.36582 18.0938 2.70544 18.0938 4.23644V20.375C18.0938 20.6458 17.9536 20.8972 17.7232 21.0396C17.4929 21.1819 17.2053 21.1949 16.9631 21.0738L9.5 17.3422L2.03689 21.0738C1.79471 21.1949 1.5071 21.1819 1.27677 21.0396C1.04645 20.8972 0.90625 20.6458 0.90625 20.375V4.23644C0.90625 2.70544 2.02378 1.36582 3.58356 1.1848Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgBookmark',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>